import {AbstractModel} from '../abstract-model';
import {Currency} from '../currency';

export class Stat extends AbstractModel {
  clicks: number | null = 0;
  conversions: number | null = 0;
  conversionRate: number | null = 0;
  revenue: number | null = 0;
  epc: number | null = 0;
  cpl: number | null = 0;
  currency: Currency | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.currency) {
      this.currency = new Currency().deserialize(input.currency);
    }

    return this;
  }
}
